import { combineReducers } from 'redux'
import counter from './counter'
import coin from './coin'

export default combineReducers({
  counter,
  coin
})
